import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';

import { ArrayType, FN } from 'common/types';

interface Props {
  onChange: FN;
  className: string;
  label?: string;
  placeholder?: string;
  dropdowns: ArrayType[];
  InputLabelProps: any;
  InputProps: any;
  value: string;
  variant?: 'standard' | 'filled' | 'outlined';
  error?: boolean;
  menuClassName?: string;
  disabled?: boolean;
}

const SelectInput = ({
  onChange,
  className,
  label,
  value = '',
  dropdowns,
  InputProps,
  InputLabelProps,
  variant,
  error,
  menuClassName,
  disabled,
}: Props) => {
  return (
    <TextField
      select
      label={label}
      name="ReactHookFormSelect"
      className={className}
      value={value}
      onChange={onChange}
      InputProps={InputProps}
      InputLabelProps={InputLabelProps}
      margin="normal"
      variant={variant ? variant : 'standard'}
      error={error}
      disabled={disabled}
    >
      {dropdowns &&
        dropdowns.map((i: ArrayType, n: number) => (
          <MenuItem value={i.value} key={n} className={menuClassName}>
            {i.text}
          </MenuItem>
        ))}
    </TextField>
  );
};
export default SelectInput;
